import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dafd1a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attendWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "my-1"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Registrierung ist für Teilnahme erforderlich", -1))
const _hoisted_5 = { id: "attendance-alert-messages" }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 0,
  class: "form"
}
const _hoisted_8 = { class: "attendName" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "nameError" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "eMailError" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 0,
  id: "attendeesError",
  class: "text-danger"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "commentError" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary mx-1",
  type: "submit"
}, "Abschicken", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Message = _resolveComponent("Message")!
  const _component_FormControlInput = _resolveComponent("FormControlInput")!
  const _component_FormControlAttributes = _resolveComponent("FormControlAttributes")!
  const _component_FormControlSlider = _resolveComponent("FormControlSlider")!
  const _component_form_control_textarea = _resolveComponent("form-control-textarea")!
  const _component_form_control_checkbox = _resolveComponent("form-control-checkbox")!
  const _component_ValidationForm = _resolveComponent("ValidationForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.maxAttendants && _ctx.maxAttendants > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, "Freie Plätze: " + _toDisplayString(_ctx.maxAttendants - _ctx.totalAttendants) + " / " + _toDisplayString(_ctx.maxAttendants), 1),
            (_ctx.totalAttendants >= _ctx.maxAttendants)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Die maximale Teilnehmerzahl für diesen Termin wurde bereits erreicht. "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.maxAttendants || _ctx.maxAttendants == 0 || _ctx.totalAttendants < _ctx.maxAttendants)
        ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAttendanceBtnClicked && _ctx.onAttendanceBtnClicked(...args)))
          }, " Für diesen Termin anmelden ", 512)), [
            [_vShow, !_ctx.showAttendance && _ctx.messages.length === 0]
          ])
        : _createCommentVNode("", true),
      (!_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_OverlayPanel, {
            key: 2,
            ref: "loginOP",
            showCloseIcon: true,
            dismissable: true,
            appendTo: "body",
            class: "wdw-widgets"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_Login, { domainid: _ctx.domainid }, null, 8, ["domainid"])
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
          return (_openBlock(), _createBlock(_component_Message, {
            onClose: _ctx.resetMessage,
            severity: message.severity,
            key: message.content
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(message.content), 1)
            ]),
            _: 2
          }, 1032, ["onClose", "severity"]))
        }), 128))
      ]),
      (_ctx.showAttendance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.isLoading && !_ctx.isAttendand && _ctx.showForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ValidationForm, {
                    name: "attendeesForm",
                    onSubmit: _ctx.onProcessForm
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.calendarConfig.name_required && !_ctx.isLoggedIn)
                          ? (_openBlock(), _createBlock(_component_FormControlInput, {
                              key: 0,
                              required: _ctx.calendarConfig.name_required,
                              label: "Name",
                              name: "name",
                              class: "filterKeyText",
                              defaultvalue: _ctx.form.name
                            }, null, 8, ["required", "defaultvalue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("div", null, [
                        (!_ctx.isLoggedIn)
                          ? (_openBlock(), _createBlock(_component_FormControlInput, {
                              key: 0,
                              required: true,
                              label: "E-Mail-Adresse",
                              type: "email",
                              name: "email",
                              defaultvalue: _ctx.form.email
                            }, null, 8, ["defaultvalue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("div", null, [
                        _createVNode(_component_FormControlAttributes, {
                          fields: _ctx.assignedAttributes,
                          groupName: "attendance",
                          elementPrefixId: "wdw-calendar-attendance",
                          onValidate: _ctx.onValidatedFormField
                        }, null, 8, ["fields", "onValidate"])
                      ]),
                      _createElementVNode("div", null, [
                        (_ctx.calendarConfig.count_attendees_required)
                          ? (_openBlock(), _createBlock(_component_FormControlSlider, {
                              key: 0,
                              required: _ctx.calendarConfig.count_attendees_required,
                              label: _ctx.attendeesFieldLabel,
                              type: "number",
                              min: 0,
                              max: _ctx.maxAttendeesAllowed,
                              name: "countAttendees",
                              defaultvalue: 0,
                              onValidate: _ctx.onAttendeesFilled
                            }, null, 8, ["required", "label", "max", "onValidate"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.errMessageAttendees != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errMessageAttendees), 1))
                        : _createCommentVNode("", true),
                      _hoisted_14,
                      _createElementVNode("div", null, [
                        (_ctx.calendarConfig.comment_required)
                          ? (_openBlock(), _createBlock(_component_form_control_textarea, {
                              key: 0,
                              required: _ctx.calendarConfig.comment_required,
                              label: "Anmerkungen",
                              class: "attendComment",
                              name: "attendComment",
                              defaultvalue: _ctx.form.comment,
                              rows: 5
                            }, null, 8, ["required", "defaultvalue"]))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.isLoggedIn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_form_control_checkbox, {
                              required: true,
                              label: _ctx.dsgvoText,
                              name: "agree_privacy"
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("button", {
                        class: "btn btn-primary mx-1",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showAttendance = !_ctx.showAttendance), ["prevent"]))
                      }, "Abbrechen")
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}